import { AddCircleOutlineOutlined } from '@mui/icons-material'
import { Alert, Button } from '@mui/material'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'

import services from '@/services'
import { useUserStore } from '@/stores/user'
import { DataTable } from '../../../components'
import { useHeaderAdmin } from '../../../hooks'
import ModalPromo from './modal-promo'
import ModalRegister from './modal-register'
import ModalUpdate from './modal-update'
import { TABLE_COLUMNS } from './table-columns'
import { TableToolbar } from './table-toolbar'
import { useData } from './use-data'
export default function Students() {
  const { setAction } = useHeaderAdmin()
  const { user, setUser, promoModal, setPromoModal } = useUserStore()
  const { isLoading, error, users } = useData()

  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState<boolean>(false)

  const toggleModalRegister = () => setIsModalRegisterOpen(!isModalRegisterOpen)

  useEffectOnce(() => {
    setAction(
      <Button onClick={toggleModalRegister}>
        <AddCircleOutlineOutlined />
        <span>Registar</span>
      </Button>,
    )
  })

  if (error) return <Alert severity="error">{(error as Error).message}</Alert>

  return (
    <>
      <ModalUpdate open={user !== null} />
      <ModalPromo open={promoModal !== null} />
      <ModalRegister open={isModalRegisterOpen} onClose={toggleModalRegister} />

      <DataTable
        data={users ?? []}
        isLoading={isLoading}
        columns={TABLE_COLUMNS}
        inputProps={{ name: 'name' }}
        toolbar={(table) => <TableToolbar table={table} />}
        actions={{
          queryKey: ['/users?type=USER'],
          async onUpdate(data) {
            setUser(data)
          },
          async onDelete(data) {
            await services.user.deleteById(data.id)
          },
          async onSetSpecialAction(data) {
            setPromoModal(data)
          },
        }}
      />
    </>
  )
}
